<template>
<v-container fluid class="page-wrap">
    <v-row>
      <v-col cols="12" class="text-center">
          <header-vue/>
      </v-col>

      <v-col
        class="mb-5"
        md="12"
      >
            <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
                <v-card-title class="page-title-row">
                    <div>
                        <div class="text-overline accent--text font-weight-bold">SETUP</div>
                        <div class="text-h6 font-weight-bold primary--text">Subjects</div>
                        <div class="text-body-2 grey--text">Manage Subjects - Add/Update/Remove</div>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="d-flex flex-wrap stat-chip-row">
                        <div class="stat-chip">
                            <div class="stat-chip-value">{{subjectCount}}</div>
                            <div class="stat-chip-label">Total Subjects</div>
                        </div>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <!-- Create /Update Form -->
                        <v-col cols="12">
                            <create-subject-form :authToken="authToken" :school="school" :classes="classes" :editFormRecord="editFormRecord" @refreshSignal="refreshSubjects = Math.random()"/>
                        </v-col>
                        <v-col cols="12">
                            <get-classes-record-axios-by-school :authToken="authToken" :school="school" @get_classes="getClasses"/>
                            <get-subjects-record-axios-by-school :authToken="authToken" :school="school" :refreshSignal="refreshSubjects" @get_subjects="getSubjects"/>
                            <v-alert
                                type="warning"
                                dense
                                border="left"
                                text
                                color="black"
                               >
                                We strongly advise against removing subject from classes that already have a history of result entries with the subject. Doing so will automatically hide the subject and the subject scores for that class.
                            </v-alert>
                        </v-col>
                        <!-- Records -->
                        <v-row class="mb-1 mt-2">
                            <v-col cols="12">
                                <v-alert
                                    type="info"
                                    dense
                                    border="left"
                                    text
                                    color="orange"
                                    >
                                    <marquee>
                                        <span v-for="(info,i) in infos" :key="i" class="black--text mr-5">
                                        {{info.content}} | &nbsp;
                                        </span>
                                    </marquee>
                                </v-alert>
                            </v-col>
                            <v-col cols="12" md="12">
                                <view-subjects-table-list :authToken="authToken" :school="school" :records="records" @editFormSignal="editFormSignal" @refreshSignal="refreshSubjects = Math.random()"/>
                            </v-col>
                            <!-- Archive -->
                        </v-row>
                    </v-row>
                </v-card-text>
            </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HeaderVue from '../../components/Header.vue'
import CreateSubjectForm from '../../components/parts/CreateSubjectForm.vue';
import GetClassesRecordAxiosBySchool from '../../components/parts/GetClassesRecordAxiosBySchool.vue';
import GetSubjectsRecordAxiosBySchool from '../../components/parts/GetSubjectsRecordAxiosBySchool.vue';
import ViewSubjectsTableList from '../../components/parts/ViewSubjectsTableList.vue';

  export default {
    name: 'Subjects',
    components: {
        HeaderVue,
        GetClassesRecordAxiosBySchool,
        GetSubjectsRecordAxiosBySchool,
        ViewSubjectsTableList,
        CreateSubjectForm
    },
    data: () => ({
        authToken:sessionStorage.getItem('authToken') ?? null,
        school:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : null,
        records:[],
        classes:[],
        editFormRecord: null,
        refreshSubjects: false,
        infos:[
            {content: 'You should check first that a subject name doesnt exist before creating another. To add subjects to classes, click the pencil icon and select all the classes offering the subject. This is to avoid subjects duplication'},
            {content: 'You need not create same subject for different classes. You can simple create the subject once and add select the classes the subject is relevant to'},
        ],
        fetchingContent:true
    }),
    mounted() {
       if (!this.authToken) {
            this.$router.push({name: 'Login'})
       }
    },
    computed:{
        subjectCount(){
            return this.records.length
        }
    },
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1.0' }
        ]
    },
    methods: {
        getClasses (data) {
            this.classes = data
        },
        getSubjects (data) {
            this.fetchingContent = false
            this.records = data
        },
        editFormSignal (data) {
            this.editFormRecord = data
        },
    },
  }
</script>
